import React from 'react';
import cn from 'classnames';
import styles from './DirectorInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import PhoneInput from '../../../../components/PhoneInput';

const DirectorInformations = ({ company, onCompanyChange, onDropdownChange, loading }) => {
    return (
        <Card className={styles.card} title="Informations du directeur" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom du directeur"
                    name="director_last_name"
                    type="text"
                    placeholder="Nom du directeur"
                    value={company?.director_last_name || ''}
                    onChange={onCompanyChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Prénom du directeur"
                    name="director_first_name"
                    type="text"
                    placeholder="Prénom du directeur"
                    value={company?.director_first_name || ''}
                    onChange={onCompanyChange}
                />
                <PhoneInput
                    className={styles.field}
                    label="Numéro de téléphone du directeur"
                    name="director_phone"
                    id="director_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={company?.director_phone || ''}
                    onChange={onCompanyChange}
                    autoComplete="tel"
                />
                <TextInput
                    className={styles.field}
                    label="Email du directeur"
                    name="director_email"
                    type="email"
                    placeholder="email@example.com"
                    value={company?.director_email || ''}
                    onChange={onCompanyChange}
                    required
                />
            </div>

            <div className={styles.divider}></div>
            <div className={styles.actions}>
                <button
                    className={cn("button", styles.button)}
                    type="submit"
                    disabled={loading}
                >
                    {loading ? "Enregistrement en cours..." : "Enregistrer les modifications"}
                </button>
            </div>
        </Card>
    );
};

export default DirectorInformations;